module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content"
  }, [(_vm.isLoading) ? _c('mu-content-block', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 32
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.hasFavourites) ? _c('div', {
    attrs: {
      "id": "lifeFavourites"
    }
  }, _vm._l((_vm.chunkedItems), function(chunks, index) {
    return _c('mu-flexbox', {
      key: 'chunk-' + index,
      staticClass: "row",
      attrs: {
        "gutter": 16
      }
    }, _vm._l((chunks), function(post, index) {
      return _c('mu-flexbox-item', {
        key: 'post-' + index,
        staticClass: "post"
      }, [_c('mu-card', [_c('router-link', {
        attrs: {
          "to": {
            name: 'LifeStyleArticle',
            params: {
              permalink: post.post_slug
            }
          }
        }
      }, [_c('mu-card-media', {
        staticClass: "imgHolder"
      }, [_c('div', {
        staticClass: "img",
        style: ({
          'background-image': 'url(' + post.post_image + ')'
        })
      })]), _vm._v(" "), _c('div', {
        staticClass: "overlay"
      }, [_c('mu-flexbox', {
        staticClass: "item",
        attrs: {
          "justify": "flex-end",
          "align": "align"
        }
      }, [_c('h3', {
        staticClass: "largeTitle"
      }, [_vm._o(_c('span', [_vm._v(_vm._s(post.post_title))]), 0, 'post-' + index)]), _vm._v(" "), _c('mu-card-text', {
        staticClass: "desc"
      }, [_c('div', {
        staticClass: "extract"
      }, [_c('div', [_vm._v(_vm._s(post.post_excerpt) + "\n                        ")])])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
        staticClass: "stats-bar"
      }, [_c('div', {
        staticClass: "stat favourites"
      }, [_c('mu-icon-button', {
        attrs: {
          "icon": post.post_favourited ? 'favorite' : 'favorite_border',
          "disabled": _vm.userId === false
        },
        nativeOn: {
          "click": function($event) {
            return _vm.favouritePost(post.post_id)
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "amount",
        domProps: {
          "textContent": _vm._s(post.post_favourites)
        }
      })], 1)])], 1)], 1)
    }), 1)
  }), 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading && !_vm.hasFavourites) ? _c('div', [_c('p', [_vm._v("You have favourited no articles")])]) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.isAppending) ? _c('mu-content-block', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 32
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32950319","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/LifeStyle/Favourites/LifeFavourites.vue
// module id = 3669
// module chunks = 1